import { handleRequest } from "../utilities/requestHandler";

export const getComplianceDocuments = (params) =>
	handleRequest("get", "/compliance/documents", params);

export const getComplianceDocumentById = (id) =>
	handleRequest("get", `/compliance/documents/${id}`);

export const createComplianceDocument = (formData) =>
	handleRequest("post", "/compliance/documents", formData, {
		headers: { "Content-Type": "multipart/form-data" },
	});

export const updateComplianceDocument = (id, formData) =>
	handleRequest("put", `/compliance/documents/${id}`, formData, {
		headers: { "Content-Type": "multipart/form-data" },
	});

export const deleteComplianceDocument = (id) =>
	handleRequest("delete", `/compliance/documents/${id}`);

export const getActiveComplianceContent = (params) =>
	handleRequest("get", "/compliance/active", params);

export const acceptCookiePolicy = (userId, cookiePolicyAccepted, documentId = null) =>
	handleRequest("post", "/auth/cookie-policy-accept", {
		user_id: userId,
		cookie_policy_accepted: cookiePolicyAccepted,
		document_id: documentId,
	});
